<template>
	<v-btn
		variant="text"
		:color="color"
		v-bind="$attrs"
		@click="confirm(text, callback)"
	>
		<slot />
	</v-btn>
</template>
<script>
import {
	confirm,
} from 'laravel-front-library';

export default {
	name: 'ConfirmButton',
	props: {
		text: {
			type: String,
			default: '',
		},
		callback: {
			type: Function,
			required: true,
		},
		color: {
			type: String,
			'default': undefined,
		},
	},
	methods: {
		confirm,
	},
};
</script>
